import React from 'react';
import { X } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function ProblemSection() {
  const {
    t
  } = useLanguage();
  const problems = [t('problem.p1'), t('problem.p2'), t('problem.p3'), t('problem.p4')];
  return <section id="problema" className="py-20 lg:py-28 bg-white" data-id="element-318">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-319">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-320">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-brand-black mb-6" data-id="element-321">
            {t('problem.title')}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brand-text/80" data-id="element-322">
            {t('problem.desc')}
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto mb-16" data-id="element-323">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1 + 0.2
        }} className="bg-brand-gray p-6 rounded-xl border border-black/5 flex items-start gap-4" data-id="element-324">
              <div className="bg-red-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-325">
                <X className="w-5 h-5 text-red-600" strokeWidth={3} data-id="element-326" />
              </div>
              <p className="text-brand-text font-medium text-lg leading-snug" data-id="element-327">
                {problem}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="text-center max-w-3xl mx-auto bg-brand-black text-white p-8 rounded-2xl shadow-xl" data-id="element-328">
          <p className="text-lg mb-4 text-white/80" data-id="element-329">{t('problem.result')}</p>
          <p className="text-2xl font-serif font-bold text-brand-gold" data-id="element-330">
            {t('problem.conclusion')}
          </p>
        </motion.div>
      </div>
    </section>;
}